import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MyEinvoiceConsolidatedReportService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/consolidated-reports'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/consolidated-reports'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/consolidated-reports'
    this.httpClient = http;
  }



  async consolidatedReportCSVExport(criteria: any, authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/csv-export/backoffice-ep/query';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .post(CSV_URL, criteria ,{ headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

  getByCriteriaConsolidatedReport(criteria: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        'e-invoice/consolidated-reports/backoffice-ep/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      criteria,
      this.getHttpHeader(visa)
    );
  }

  getCountByCriteriaConsolidatedReport(criteria: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        'e-invoice/consolidated-reports/total-records/backoffice-ep/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      criteria,
      this.getHttpHeader(visa)
    );
  }

  async detailConsolidatedReportCSVExport(criteria: any, authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/detail/csv-export/backoffice-ep/query';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .post(CSV_URL, criteria ,{ headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

  getByCriteriaDetailConsolidatedReport(criteria: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        'e-invoice/consolidated-reports/detail/backoffice-ep/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      criteria,
      this.getHttpHeader(visa)
    );
  }

  getCountByCriteriaDetailConsolidatedReport(criteria: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        'e-invoice/consolidated-reports/detail/total-records/backoffice-ep/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      criteria,
      this.getHttpHeader(visa)
    );
  }

}
